export function exitDelayMs(): number {
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--exit-ms').trim()
  return Number.parseFloat(raw) || 0
}

export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export const DISMISS_DISTANCE_RATIO = 0.25
export const DISMISS_VELOCITY_PX_PER_S = 500
